
<template>
  <div class="auditpage">
    <div class="header"><img src="../../assets/images/init.png"></div>
    <div id="shadow"><img src="../../assets/images/yinying.png" ></div>
    <div class="main">
      <img src="../../assets/images/shenhe.png" alt="">
    </div>
    <div class="info">您的账号正在审核中，请耐心等待哦</div>
    <div class="btn">
      <div class="backbtn" @click="routeTo">返回首页</div>
    </div>
    <div class="biao"><img src="../../assets/images/bkcc.png" alt=""></div>
    <div class="footer">北京北科互联城市治理技术研究院有限公司&nbsp;&nbsp;&nbsp;&nbsp;
      <a class="icp" target="_blank" href="https://beian.miit.gov.cn/">京ICP备19000636号-1</a>
    </div>
  </div>
</template>
<script type="es6">
  var vm;
  export default {
    name: 'auditpage',
    data (){
      return {

      }
    },
    components: {

    },

    created: function(){

    },

    methods:{
      routeTo(){
        this.$router.push('/');
      }
    }
  }

</script>
<style scoped>
  .header{
    width:100%;
    height:91px;
    margin: 0 auto;
    line-height: 91px;
    font-size: 30px;
    color:#3c7ce6;
    font-weight: bold;
    position: relative;
    background: #ffffff;
  }
  .header img{
    position: absolute;
    left:13.5%;
    top:31%;
  }
  #shadow{
    margin-top:-10px;
  }
  #shadow img{
    width: 100%;
  }
  .main{
    width:613px;
    height:552px;
    margin:0 auto;
    position: relative;
  }
  .main img{
    position: absolute;
    top:-8px;
  }
  .info{
    text-align:center;
    margin-top:50px;
    font-size: 18px;
    color:#8a8a8a;
  }
  .backbtn{
    width:148px;
    height:40px;
    border:1px solid #ff7b44;
    color:#fff;
    text-align:center;
    margin:0 auto;
    line-height: 40px;
    font-size: 15px;
    border-radius:4px;
    cursor: pointer;
    margin-top:20px;
    background-color: #ff7b44;
  }
  /*.backbtn:hover{
      background-color: #3c7ce6;
      color:#fff;
      border-radius:4px;
      border-radius:4px;
      cursor: pointer;
  }*/
  .biao{
    width:80px;
    height:11px;
    margin:0 auto;
    margin-top:60px;
  }
  .footer{
    text-align:center;
    margin-top:18px;
    color:#666666;
  }
</style>
